import { Button } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { AppModal } from '../../../components/general/AppModal'
import { serviceAdapter } from '../../../service/serviceAdapter'

interface ExitRegistrationModalProps {
  isOpen: boolean
  title: string
  onCancel: () => void
  onConfirm?: () => void
}

export const ExitRegistrationModal: React.FC<PropsWithChildren<ExitRegistrationModalProps>> = observer(
  ({ children, isOpen, title, onCancel, onConfirm }) => {
    const { t } = useTranslation()

    const handleCancel = () => {
      onCancel()
    }

    const handleConfirm = () => {
      onConfirm ? onConfirm() : serviceAdapter.handleLogOut()
    }

    return (
      <AppModal
        id="registration_exit_modal"
        isOpen={isOpen}
        title={title}
        onClose={handleCancel}
        showCloseButton={false}
        controls={
          <>
            <Button
              id="button_cancel_exit_registration"
              type="button"
              size="sm"
              contentMode="secondary"
              hasBackground={false}
              onClick={handleCancel}
            >
              {t('general.cancel')}
            </Button>
            <Button
              id="button_confirm_exit_registration"
              type="button"
              size="sm"
              contentMode="primary"
              onClick={handleConfirm}
            >
              {t('registration.buttons.exit')}
            </Button>
          </>
        }
      >
        {children}
      </AppModal>
    )
  }
)
